module.exports = __webpack_public_path__ + "static/media/earlyvoting.70af7e6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/earlyvoting.png
// module id = 61
// module chunks = 0